import { config } from '../../themes';
import type { StitchesCSS } from '../../themes';

/**
 * NOTE:
 * https://github.com/modulz/stitches/pull/721
 */
function genDynamicVariant<
  P extends keyof typeof config.theme,
  T extends keyof typeof config.theme[P],
  R extends Record<T, StitchesCSS>
>(prop: P, map: (value: T) => StitchesCSS): R {
  const values = Object.keys(config.theme[prop]) as T[];

  return values.reduce<R>(
    (acc, value) => ({
      ...acc,
      [value]: map(`$${value}` as T),
    }),
    {} as R
  );
}

export default genDynamicVariant;
